import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
  [id: string]: {
    url: string;
    expires: number;
    loaded: boolean;
  };
}

const initialState: State = {};
const MAX_CACHE_TIMES = 8 * 60 * 1000;

const quill = createSlice({
  name: 'quill',
  initialState,
  reducers: {
    setRecord: (state, action: PayloadAction<{ id: string; url: string }>) => {
      const { id, url } = action.payload;
      state[id] = { url, expires: Date.now() + MAX_CACHE_TIMES, loaded: false };
      return state;
    },
    setLoaded: (state, action: PayloadAction<{ id: string }>) => {
      const { id } = action.payload;
      if (id && state[id]) {
        state[id].loaded = true;
      }
      return state;
    },
  },
});
export const { setRecord, setLoaded } = quill.actions;
export default quill.reducer;
